<template>
  <layout-fullscreen bg="/images/photo-2.jpg">
    <div class="body">
      <h1 class="heading h2 t-inverse t-center">
        Login to your account with
      </h1>

      <div class="button-group">
        <button class="button button--inverse button--inline-icon" @click="handleSocialAuth(facebookUrl)">
          <img class="icon" src="@/assets/icons/facebook.svg" alt="" role="presentation">
          Facebook
        </button>
        <button class="button button--inverse button--inline-icon" @click="handleSocialAuth(googleUrl)">
          <img class="icon" src="@/assets/icons/google.svg" alt="" role="presentation">
          Google
        </button>
      </div>

      <div class="hr">or</div>

      <form-base @submit.native.prevent="submit">
        <form-input type="text" label="Email address" placeholder="e.g. john.doe@example.com" v-model="uid" :error="hasError('uid')" :inverse="true" />
        <form-input type="password" label="Password" placeholder="********" v-model="password" :error="hasError('password')" :inverse="true" />
        <router-link class="forgot-password button button--link button--link-inverse button--link-inline" to="forgot-password">Forgot password?</router-link>
        <div class="error-block" v-if="hasError('mustVerify')">{{ hasError('mustVerify') }}</div>
        <button type="submit" class="button button--inverse">Login</button>
        <a class="button button--link button--link-inverse" @click="$router.back()">Cancel</a>
      </form-base>
    </div>
  </layout-fullscreen>
</template>

<style scoped lang="scss">
  .heading {
    max-width: 350px;

    @include min-sm {
      max-width: 450px;
    }
  }

  .hr {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 30px 0;

    color: rgb(var(--white));
    font-size: var(--small);

    &:before,
    &:after {
      display: block;
      width: 100%;
      content: '';
      border-bottom: 1px solid rgb(var(--white));
    }

    &:before {
      margin-right: 20px;
    }

    &:after {
      margin-left: 20px;
    }
  }

  .error-block {
    display: block;
    width: 100%;
    margin-bottom: 20px;
    padding: 0.5em;
    border-radius: 4px;
    background-color: rgb(var(--red-0));

    font-size: var(--small);
    font-weight: var(--weight-bold);
    color: rgb(var(--white));
    text-align: center;
  }

  .forgot-password {
    align-self: flex-end;
    margin-bottom: 30px;
  }
</style>

<script>
  import { mapActions } from 'vuex';
  import { backend } from '@/api';
  import form from '@/mixins/form';
  import socialAuth from '@/mixins/socialAuth';

  import LayoutFullscreen from '@/layouts/Fullscreen';
  import FormBase from '@/components/FormBase';
  import FormInput from '@/components/FormInput';
  import Navigation from '@/components/Navigation';

  export default {
    name: 'AccountIntro',

    mixins: [form, socialAuth],

    components: {
      LayoutFullscreen,
      FormBase,
      FormInput,
      Navigation,
    },

    data: () => ({
      uid: '',
      password: ''
    }),

    methods: {
      ...mapActions([
        'setUser'
      ]),

      submit () {
        const { uid, password } = this;

        backend.auth.email.login({ uid, password })
          .then(({ data }) => {
            this.setUser(data);
            this.$router.push('/wizard');
          })
          .catch(({ response }) => {
            this.errors = response.data.messages;
          })
      }
    }
  };
</script>